import styled from 'styled-components'

import { theme } from '../../../styles/theme'

export const Container = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 2;

  padding: 24px;
  width: 100%;

  border: 1px solid ${theme.colors.gray200};
  border-radius: ${theme.border.mediumRadius};
  background: ${theme.colors.white};
  box-shadow: 0px 3px 5px 0px rgba(175, 178, 187, 0.2);

  display: flex;
  flex-direction: column;
  gap: 24px;

  animation: slide-down 0.3s ease-in-out;

  @keyframes slide-down {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  max-height: 300px;
  overflow-y: auto;

  & > button:first-child {
    align-self: flex-end;
    margin: 0;

    font-size: ${theme.font.sizes.xsmall};
    width: unset;
    padding: 8px;
    border-radius: ${theme.border.smallRadius};
  }
`

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Schedules = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 30px;
`

export const ApplyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 16px;

  border: none;
  border-radius: ${theme.border.mediumRadius};
  background: ${theme.colors.green1};

  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};

  @media (min-width: 768px) {
    width: 200px;
    margin: 0 auto;
  }
`
